export const environment = {
  production: false,
  baseUrl: "https://api.sbesatp.org/v1/"
};
